import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import { hasFlag, normalizeAvoidTollRoadFlags, withDisabledAvoidTollRoadFlags } from "helpers/avoidTollRoadFlags";
import {
    avoidTollRoadFlagsEnum,
    featureModuleTypesEnum,
    routerProfiles,
    routerTypes,
    routerTypesEnum,
} from "helpers/enums";
import { getClientRouteOptions } from "helpers/regionDryingPeriods";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import React from "react";
import { config, initialState } from "./config";

const { Yatrs, Here, GraphHopper } = routerTypesEnum;

class RouterSettings extends PanelTemplate {
    normalizeData = (data) => ({
        ...getClientRouteOptions(data),
        avoidTollRoadFlags: normalizeAvoidTollRoadFlags(data.avoidTollRoadFlags),
    });

    renderBody = () => {
        const {
            editable,
            config,
            profile: { availableFeatureModules },
        } = this.props;
        const { routerType, ...rest } = config;
        const data = this.normalizeData(this.state.data);

        const hereEnabled = availableFeatureModules.includes(featureModuleTypesEnum.HereServices);

        return (
            <>
                {this.renderSelect({
                    ...routerType,
                    disabled: !editable,
                    options: routerTypes.filter(
                        (item) => (hereEnabled || item.value !== Here) && item.value !== GraphHopper,
                    ),
                })}
                {Object.values(rest).map((conf) => {
                    if (!conf.available(data)) {
                        return null;
                    }
                    const isRouterProfile = conf.inputProps.name === "routerProfile";
                    if (conf.options) {
                        return this.renderSelect({
                            ...conf,
                            validators: isRouterProfile ? [requiredField] : [],
                            disabled: !editable,
                            options: isRouterProfile ? routerProfiles : conf.options,
                        });
                    }
                    switch (conf.type) {
                        case "checkbox":
                            return this.renderCheckbox({
                                ...conf,
                                disabled:
                                    !editable ||
                                    (hasFlag(data.avoidTollRoadFlags, avoidTollRoadFlagsEnum.M12WithoutDRT) &&
                                        !data.disallowTollExceptM12DRT &&
                                        conf.inputProps.name === "disallowTollExceptM12DRT") ||
                                    (data.disallowTollExceptM12DRT && conf.inputProps.name === "disallowToll") ||
                                    (data.disallowTollExceptM12DRT && conf.inputProps.name === "disallowTollExceptM4") ||
                                    (data.disallowTollExceptM4 && conf.inputProps.name === "disallowToll") ||
                                    (data.disallowTollExceptM4 && conf.inputProps.name === "disallowTollExceptM12DRT") ||
                                    (data.disallowToll && conf.inputProps.name === "disallowTollExceptM12DRT") ||
                                    (data.disallowToll && conf.inputProps.name === "disallowTollExceptM4"),
                            });
                        case "flags": {
                            const isAvoidTollRoadFlags = conf.inputProps.name === "avoidTollRoadFlags";
                            const flags = conf.flags(data);

                            return this.renderFlags({
                                ...conf,
                                value: data[conf.inputProps.name],
                                flags: isAvoidTollRoadFlags
                                    ? withDisabledAvoidTollRoadFlags(flags, data.avoidTollRoadFlags)
                                    : flags,
                                disabled:
                                    !editable ||
                                    ((data.disallowToll ||
                                        data.disallowTollExceptM4 ||
                                        data.disallowTollExceptM12DRT) &&
                                        isAvoidTollRoadFlags),
                            });
                        }
                        default:
                            return this.renderField({ ...conf });
                    }
                })}
            </>
        );
    };

    setValue = ({ value, name }) => {
        const data = this.normalizeData({ ...this.state.data, [name]: value });
        const shouldUpdate = this.compareStateAndProps(this.props.data, data);
        const isValid = this.isValidForm(data);
        this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    update = () => {
        const { shouldUpdate } = this.state;
        const data = this.normalizeData(this.state.data);
        if (data.country === "") {
            data.country = null;
        }

        if (shouldUpdate && this.isValidForm(data)) {
            if (data.useSpecialProfileForEmptyRoute && !this.props.useSpecialProfileForEmptyRoute) {
                ymEvent("Hgv15tOptimalProfileActivated");
            }
            const action = () => {
                this.props
                    .action(data)
                    .then((defaultRouteOptions) => {
                        if (defaultRouteOptions) {
                            this.props.update();
                        } else {
                            this.setState({ isValid: false });
                        }
                    })
                    .then(() => this.setState({ shouldUpdate: false }));
            };

            if (this.props.data.useCargorunRouterOnly && data.routerType !== Yatrs) {
                return this.props.modal({
                    name: "confirm",
                    title: "Изменить маршрутизатор?",
                    text: "Переключение маршрутизатора приведет к отключению настройки “Использовать только навигацию CARGO.RUN в МП Водители”.",
                    onSuccessAction: () => this.props.update(),
                    action,
                    buttons: { confirm: "Да", cancel: "Нет" },
                });
            }

            return action();
        }
        this.setState({ isValid: false });
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Настройка маршрутизатора</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <RouterSettings {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
